<template>
  <vs-popup
    class="add-price-tiers-item-to-cart-pop-up"
    id="popup"
    :title="`CALCULATE LIST PRICE (${price_details.formulation_code})`"
    @close="onClickClose()"
    :active.sync="open"
    :buttons-hidden="true"
  >
    <vx-card no-shadow>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form
          @submit.prevent="handleSubmit(onClickAddItemToCart)"
          autocomplete="off"
        >
          <div class="vx-row mb-3 mt-8">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider
                vid="quantity"
                name="quantity"
                v-slot="{ errors }"
              >
                <small class="label">Quantity needed (KG)</small>
                <vs-input
                  size="large"
                  v-on:input="onTypeQuantity"
                  v-model="createForm.quantity"
                  name="quantity"
                  class="w-full"
                  label=""
                  :danger="!!errors[0]"
                  :danger-text="errors[0]"
                  val-icon-danger="icon-x"
                  val-icon-pack="feather"
                />
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider
                vid="price"
                name="price"
                rules="required"
                v-slot="{ errors }"
              >
                <small class="label">Unit price (Excl vat)</small>
                <vx-input-group class="">
                  <template slot="prepend">
                    <div class="prepend-text bg-warning">
                      <span>{{ account_currency }}</span>
                    </div>
                  </template>
                  <vs-input
                    size="large"
                    readonly
                    v-model="createForm.total"
                    name="price"
                    class="required"
                    label=""
                  />
                </vx-input-group>
              </ValidationProvider>
            </div>
          </div>
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button
              button="submit"
              class="ml-auto mt-2"
              :disabled="!createForm.quantity"
              >Add</vs-button
            >
            <vs-button
              @click="createForm = {}"
              class="ml-4 mt-2"
              type="border"
              color="warning"
              >Reset</vs-button
            >
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import Calculations from "@/mixins/Calculations";

function initialState() {
  return {
    open: false,
    index: null,
    customerId: null,
    price_details: {},
    createForm: {},
  };
}

export default {
  name: "CalculateListPrices",
  data() {
    return initialState();
  },
  mixins: [Calculations],
  mounted() {
    this.$emit("calc_list_price", this);
  },
  props: {
    account_currency: {
      type: String,
      default: "",
    },
  },
  methods: {
    async openPopup(price_details, index, customerId = null) {
      Object.assign(this.$data, initialState())
      this.price_details = price_details;
      this.index = index;
      this.customerId = customerId;
      this.open = true;
    },
    async onTypeQuantity() {
      const total =  this.calculateProductListPrice(this.price_details.gbp_price, this.createForm.quantity)
      this.createForm.total = total
    },
    async onClickAddItemToCart () {
        const payload = {
            quantity : Number(this.createForm.quantity) * 1000,
            price: this.createForm.total,
        }
        this.$emit('onItemUpdated',payload, this.index)
        this.open = false
    },
    onClickClose() {
      this.open = false
    },
  },
};
</script>

<style scoped>
.add-price-tiers-item-to-cart-pop-up >>> .vs-popup {
  /*min-height: 50% !important;*/
  min-width: 35% !important;
}
</style>
